import Nullstack from 'nullstack';
export default function IconBrandCitymapper({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-citymapper",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 11a1 1 0 1 1 -1 1.013a1 1 0 0 1 1 -1v-.013z"
  }), "   ", Nullstack.element("path", {
    d: "M21 11a1 1 0 1 1 -1 1.013a1 1 0 0 1 1 -1v-.013z"
  }), "   ", Nullstack.element("path", {
    d: "M8 12h8"
  }), "   ", Nullstack.element("path", {
    d: "M13 9l3 3l-3 3"
  }), " ");
}